import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts';
import { useTranslation } from "react-i18next";
import { BiBorderRadius } from 'react-icons/bi';

const useStyles = makeStyles((theme) => ({
    syncChart: {
        padding: '10px 20px 20px'
    },
    titleChart: {
      textAlign: 'center',
      fontSize: '15px',
      fontWeight: '500',
      color: '#00a351',
      marginBottom: '25px'
    },
    notiChart: {
      display: 'flex',
      justifyContent: 'end',
      gap: '10px',
      marginTop: '10px'
    },
    notiTotalSync: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      background: '#666',
      padding: '15px 10px',
      borderRadius: '5px',
      width: '220px'
    },
    notiTotalSyncCus: {
      background: '#ccf2e7'
    },
    notiTotalSyncTime: {
      background: '#d4d4d4'
    },
    textNoti: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      color: '#666',
      fontSize: '16px'
    },
    textTooltip: {
      fontSize: '14px',
      color: '#00a351',
      display: 'flex',
    },
    textTooltipLabel: {
      color: 'black',
      fontSize: '14px',
    }
}));

export default function SyncChart (props) {
  const {
    data,
    selectedFanPage,
    selectedSystem
  } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  // Tổng số khách hàng
  const totalSyncCus = data.reduce((acc, curr) => acc + curr.totalCus, 0);

  // Tổng số lần đồng bộ 
  const totalSyncTimes = data.reduce((acc, curr) => acc + curr.count, 0);

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div style={{ background: '#fff', border: '1px solid #ccc', padding: 10, }}>
          <div className={classes.textTooltipLabel}>{label}</div>
          <div className={classes.textTooltip}>{t('synchronize_management.amount_customer')}: <p style={{marginLeft: '5px'}}>{data.totalCus}</p></div>
          <div className={classes.textTooltip}>{t('synchronize_management.amount_sync')}<p style={{marginLeft: '5px'}}>{data.count}</p></div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className={classes.syncChart}>
      <div className={classes.titleChart}>{t('synchronize_management.title_chart')}</div>
      <div style={{ width: '100%', height: 400 }}>
        {!selectedFanPage || !selectedSystem ? 
        (<div className={classes.textNoti}>
            {t('synchronize_management.select_condition')}
          </div>) : (<div className={classes.textNoti}>
            {data.length > 0 ? (
              <ResponsiveContainer>
                <BarChart data={data}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="date" tick={{ fontSize: 14}} />
                  <YAxis tick={{ fontSize: 14}}/>
                  <Tooltip content={<CustomTooltip />} />
                  <Bar dataKey="totalCus" fill="rgb(0 163 81)"/>
                </BarChart>
              </ResponsiveContainer>
            ) : (
              <div className={classes.textNoti}>
                {t('synchronize_management.no_data')}
              </div>
            )}
          </div>)}
          
        {data.length > 0 ? (<div className={classes.notiChart}>
          <div className={`${classes.notiTotalSync} ${classes.notiTotalSyncCus}`}>
            {t('synchronize_management.total_cus')}
            <strong style={{fontSize: '16px'}}>{totalSyncCus}</strong>
          </div>
          <div className={`${classes.notiTotalSync} ${classes.notiTotalSyncTime}`}>
            {t('synchronize_management.total_number_sync')}
            <strong style={{fontSize: '16px'}}>{totalSyncTimes}</strong>
          </div>
        </div>):(null)}
      </div>
    </div>
  );
};
